import { render, staticRenderFns } from "./IndustryCategory.vue?vue&type=template&id=8907a6fe"
import script from "./IndustryCategory.vue?vue&type=script&lang=js"
export * from "./IndustryCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports